import {
  Box,
  CssBaseline,
  styled,
  keyframes,
  Stack,
  Button,
} from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import PhoneIcon from "@mui/icons-material/Phone";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { Link } from "react-router-dom";
import { paths } from "../routes/path";

export default function MainLayout({ children }) {
  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          bgcolor: "background.default",
        }}
      >
        <Header />
        <Box component="main">{children}</Box>
        <Footer />

        <Button
          variant="contained"
          startIcon={<PhoneIcon />}
          href="tel:6364903820"
          sx={{
            bgcolor: "#0265fe",
            color: "white",
            fontWeight: 600,
            fontSize: "14px",
            textTransform: "none",
            borderRadius: "24px",
            "&:hover": {
              bgcolor: "#008ae6",
            },
            display: { xs: "none", sm: "flex" },
            position: "fixed",
            bottom: "30px",
            zIndex: 999,
            p: "12px 16px",
            width: "fit-content",
            left: "1.9rem",
          }}
        >
          Call Us
        </Button>

        <Box
          sx={{
            display: { xs: "block", sm: "none" },
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            bgcolor: "white",
            boxShadow: "0px -2px 10px rgba(0,0,0,0.1)",
            p: 1.2,
            zIndex: 999,
          }}
        >
          <Stack direction="row" spacing={2} justifyContent="center">
            {/* Contact Us */}
            <Button
              variant="contained"
              startIcon={<PhoneIcon />}
              href="tel:6364903820"
              sx={{
                flex: 1,
                bgcolor: "#0265fe",
                color: "white",
                fontWeight: 600,
                fontSize: "14px",
                borderRadius: "10px",
                textTransform: "none",
                "&:hover": {
                  bgcolor: "#008ae6",
                },
              }}
            >
              Call Us
            </Button>

            {/* Apply Now */}
            <Button
              variant="contained"
              component={Link}
              to={paths.dashboard.contactUs}
              startIcon={<AssignmentTurnedInIcon />}
              sx={{
                flex: 1,
                bgcolor: "#0265fe",
                color: "white",
                fontWeight: 600,
                fontSize: "14px",
                borderRadius: "10px",
                textTransform: "none",
                "&:hover": {
                  bgcolor: "#008ae6",
                },
              }}
            >
              Apply Now
            </Button>
          </Stack>
        </Box>
      </Box>
    </>
  );
}
